import './about.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight, 
  faGraduationCap, 
  faChartLine, 
  faCertificate,
  faCheckCircle,
  faBookOpen,
  faLaptopCode,
  faClock,
  faUsers,
  faAward
} from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';

const CursuriPresentation = () => {
  return (
    <div className="general-container-footer-info-ab">
      <div className="info-footer-container-ab">
        <section className='section-about-1'>
          <div>
            <h3 className='align-about-ab'>
              <span className='acasa-about-footer'>Acasa</span>
              <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
              <span className='color-despre'>Cursuri</span>
            </h3>
          </div>
        </section>

        <div className='tittle-ab-top'>
          <h4>Cursuri interactive de contabilitate</h4>
        </div>

        <div className='career-hero'>
          <p className='hero-subtitle'>Învață contabilitatea în propriul ritm, cu lecții interactive și aplicații practice</p>
          <div className='stats-career'>
            <div className='stat-item-career'>
              <FontAwesomeIcon icon={faGraduationCap} className='stat-icon-career' />
              <div className='stat-number-career'>300+</div>
              <div className='stat-label-career'>Lecții interactive</div>
            </div>
            <div className='stat-item-career'>
              <FontAwesomeIcon icon={faUsers} className='stat-icon-career' />
              <div className='stat-number-career'>10,000+</div>
              <div className='stat-label-career'>Studenți activi</div>
            </div>
            <div className='stat-item-career'>
              <FontAwesomeIcon icon={faCertificate} className='stat-icon-career' />
              <div className='stat-number-career'>100%</div>
              <div className='stat-label-career'>Certificare online</div>
            </div>
          </div>
        </div>

        <section className='section-about-2'>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faBookOpen} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
          </div>
          <div className='part-text-about'>
            <h4>De ce să alegi cursurile noastre?</h4>
            <p>
              Cursurile ContaLearn sunt create special pentru cei care doresc să învețe contabilitatea de la zero sau să-și perfecționeze cunoștințele existente.
            </p>
            <p>
              Fiecare curs este structurat progresiv, cu explicații clare, exemple practice și exerciții interactive care te ajută să înțelegi și să aplici conceptele învățate.
            </p>
            <p>
              La finalul fiecărui curs primești un certificat digital care atestă parcurgerea materialului și stăpânirea conceptelor de contabilitate.
            </p>
          </div>
        </section>

        <div className='section-header-career'>
          <h2>Cursuri disponibile</h2>
          <p className='section-subtitle-career'>Alege cursul potrivit pentru nivelul tău</p>
        </div>

        <section className="open-roles">
          <div className="job-category">
            <div className='job-category-header'>
              <FontAwesomeIcon icon={faGraduationCap} className='job-icon' />
              <h3>Bazele Contabilității</h3>
              <span className='job-badge'>Începători</span>
            </div>
            <p className='job-category-description'>
              Cursul perfect pentru cei care pornesc de la zero. Învață conceptele fundamentale ale contabilității într-un mod interactiv și ușor de înțeles.
            </p>
            <div className='job-listings'>
              <div className='job-card'>
                <div className='job-card-header'>
                  <h4>Ce vei învăța?</h4>
                </div>
                <ul className='job-requirements'>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Principiile contabilității în partidă dublă</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Înregistrarea operațiunilor economice</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Balanța de verificare</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Conturi și planul de conturi</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Documentele justificative</li>
                </ul>
                <div className='job-footer'>
                  <div className='job-meta'>
                    <span><FontAwesomeIcon icon={faClock} /> 50+ lecții</span>
                    <span><FontAwesomeIcon icon={faChartLine} /> Nivel: Începător</span>
                  </div>
                  <Link to='/login' className='apply-button'>
                    Începe cursul
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="job-category">
            <div className='job-category-header'>
              <FontAwesomeIcon icon={faLaptopCode} className='job-icon' />
              <h3>Contabilitate Financiară</h3>
              <span className='job-badge job-badge-advanced'>Avansat</span>
            </div>
            <p className='job-category-description'>
              Perfecționează-ți cunoștințele cu concepte avansate de contabilitate financiară. Ideal pentru cei care vor să-și aprofundeze expertiza.
            </p>
            <div className='job-listings'>
              <div className='job-card'>
                <div className='job-card-header'>
                  <h4>Ce vei învăța?</h4>
                </div>
                <ul className='job-requirements'>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Situații financiare (Bilanț, Cont de profit și pierdere)</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Amortizarea și deprecierea activelor</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Provisions și ajustări contabile</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Închiderea exercițiului financiar</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Raportări contabile conforme IAS/IFRS</li>
                </ul>
                <div className='job-footer'>
                  <div className='job-meta'>
                    <span><FontAwesomeIcon icon={faClock} /> 80+ lecții</span>
                    <span><FontAwesomeIcon icon={faChartLine} /> Nivel: Avansat</span>
                  </div>
                  <Link to='/login' className='apply-button'>
                    Începe cursul
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='section-about-2' style={{marginTop: '60px'}}>
          <div className='part-text-about'>
            <h4>Cum funcționează?</h4>
            <div style={{display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '20px'}}>
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '15px'}}>
                <div style={{minWidth: '40px', height: '40px', borderRadius: '50%', background: 'linear-gradient(135deg, #13b8ab, #0fa89a)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', fontSize: '18px'}}>1</div>
                <div>
                  <h5 style={{margin: '0 0 8px 0', color: '#202124'}}>Alege cursul</h5>
                  <p style={{margin: 0, color: '#666'}}>Selectează cursul potrivit pentru nivelul tău de cunoștințe</p>
                </div>
              </div>
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '15px'}}>
                <div style={{minWidth: '40px', height: '40px', borderRadius: '50%', background: 'linear-gradient(135deg, #13b8ab, #0fa89a)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', fontSize: '18px'}}>2</div>
                <div>
                  <h5 style={{margin: '0 0 8px 0', color: '#202124'}}>Învață în ritmul tău</h5>
                  <p style={{margin: 0, color: '#666'}}>Parcurge lecțiile interactive și rezolvă exercițiile practice</p>
                </div>
              </div>
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '15px'}}>
                <div style={{minWidth: '40px', height: '40px', borderRadius: '50%', background: 'linear-gradient(135deg, #13b8ab, #0fa89a)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', fontSize: '18px'}}>3</div>
                <div>
                  <h5 style={{margin: '0 0 8px 0', color: '#202124'}}>Primește certificarea</h5>
                  <p style={{margin: 0, color: '#666'}}>Obține certificatul digital la finalul cursului</p>
                </div>
              </div>
            </div>
          </div>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faAward} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
          </div>
        </section>

        <div style={{textAlign: 'center', margin: '60px 0'}}>
          <h3 style={{fontSize: '32px', color: '#202124', marginBottom: '20px'}}>Gata să începi?</h3>
          <p style={{fontSize: '18px', color: '#666', marginBottom: '30px'}}>Creează-ți cont gratuit și începe primul curs astăzi!</p>
          <Link to='/registrer' style={{
            display: 'inline-block',
            padding: '16px 48px',
            background: 'linear-gradient(135deg, #13b8ab 0%, #0fa89a 100%)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '50px',
            fontWeight: '700',
            fontSize: '18px',
            boxShadow: '0 4px 15px rgba(19, 184, 171, 0.3)',
            transition: 'all 0.3s ease'
          }}>
            Creează cont gratuit
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CursuriPresentation;
